import { styled } from "@mui/material";
import { CheckoutContext } from "../../checkoutUIMachine";
import { useCheckoutUI } from "../../CheckoutUIProvider";

const DebugContainer = styled("div")({
  padding: "16px",
  backgroundColor: "#f5f5f5",
  borderRadius: "8px",
  marginTop: "20px",
  fontFamily: "monospace",
  fontSize: "12px",
  whiteSpace: "pre-wrap",
});

const DebugSection = styled("div")({
  marginBottom: "12px",
});

const DebugTitle = styled("div")({
  fontWeight: "bold",
  marginBottom: "4px",
  color: "#666",
});

const DebugPanel = () => {
  const [state] = useCheckoutUI();

  // Cast the context to the proper type to avoid TypeScript errors
  const context = state.context as unknown as CheckoutContext;

  const { signIn, shipping, payment, retailerLogin, userId, shippingInput } =
    context;

  return (
    <DebugContainer>
      <DebugSection>
        <DebugTitle>State Machine State</DebugTitle>
        <div>Current State: {JSON.stringify(state.value)}</div>
        <div>User ID: {userId}</div>
      </DebugSection>

      <DebugSection>
        <DebugTitle>Steps</DebugTitle>
        <div>Sign In: {JSON.stringify(signIn, null, 2)}</div>
        <div>Payment: {JSON.stringify(payment, null, 2)}</div>
        <div>Shipping: {JSON.stringify(shipping, null, 2)}</div>
        <div>Retailer Login: {JSON.stringify(retailerLogin, null, 2)}</div>
      </DebugSection>

      <DebugSection>
        <DebugTitle>Shipping Input</DebugTitle>
        <div>
          {shippingInput ? JSON.stringify(shippingInput, null, 2) : "Not set"}
        </div>
      </DebugSection>
    </DebugContainer>
  );
};

export default DebugPanel;
